import { TextField } from '@client/new/components/basic';
import { Switch } from '@mui/material';
import { Controller } from 'react-hook-form';
import _ from 'lodash';
import { NewCreatorViewModel } from './newCreator.viewModel';
import { FormTier } from './FormTier';

export function NewCreatorForm({
  control,
  register,
  hasFreeSubscription,
  onboardingEnabled,
  tier,
}: NewCreatorViewModel) {
  const x = register('firstName');
  return (
    <div id="form" className="bg-white p-6 rounded-[20px] flex flex-col gap-6">
      <div className="flex gap-6">
        <div className="w-full">
          <span className="p-1 leading-5 text-sm font-medium">First Name </span>
          <TextField placeholder="Enter" className="w-full" {...x} />
        </div>
        <div className="w-full">
          <span className="p-1 leading-5 text-sm font-medium">Last Name</span>
          <TextField
            placeholder="Enter"
            className="w-full"
            {...register('lastName')}
          />
        </div>
      </div>
      <div className="flex gap-6">
        <div className="w-full">
          <span className="p-1 leading-5 text-sm font-medium">Instagram</span>
          <TextField
            placeholder="Enter"
            className="w-full"
            {...register('profileInstagram')}
          />
        </div>
        <div className="flex flex-col w-full">
          <span className="p-1 leading-5 text-sm font-medium">Tier</span>
          <FormTier {...tier} />
          {tier?.error && (
            <span className="text-[#F04438] text-[12px] ml-3.5">
              {tier.error.message}
            </span>
          )}
        </div>
      </div>
      <div className="w-full">
        <span className="p-1 leading-5 text-sm font-medium">E-mail</span>
        <TextField
          placeholder="Enter"
          className="w-full"
          {...register('email')}
        />
      </div>
      <div>
        <div className="w-full">
          <span className="p-1 leading-5 text-sm font-medium">
            Re-enter e-mail
          </span>
          <TextField
            placeholder="Enter"
            className="w-full"
            {...register('repeatEmail')}
          />
        </div>
      </div>
      <div>
        <div className="w-full">
          <span className="p-1 leading-5 text-sm font-medium">
            Generate free subscription
          </span>
          <Controller
            name={'freeSubscription'}
            control={control}
            render={({ field: { onChange, value } }) => (
              <Switch checked={value} onChange={onChange} id="free-sub" />
            )}
          />
          <span className="p-1 leading-5 text-sm font-medium">
            {hasFreeSubscription ? <span>Yes</span> : <span>No</span>}
          </span>
        </div>
      </div>
      <div>
        <div className="w-full">
          <span className="p-1 leading-5 text-sm font-medium">
            Onboarding enabled
          </span>
          <Controller
            name={'onboardingEnabled'}
            control={control}
            render={({ field: { onChange, value } }) => (
              <Switch
                checked={value}
                onChange={onChange}
                id="onboarding-enabled"
              />
            )}
          />
          <span className="p-1 leading-5 text-sm font-medium">
            {onboardingEnabled ? <span>Yes</span> : <span>No</span>}
          </span>
        </div>
      </div>
    </div>
  );
}
